// src/hooks/useTranslateText.js
import { useAuth0 } from "@auth0/auth0-react";

export const useTranslateText = () => {
  const { getAccessTokenSilently } = useAuth0();

  const translateText = async (
    sourceText,
    targetLang,
    sourceLanguage = "en"
  ) => {
    console.log("sourceText ", sourceText, "targerLAng ", targetLang)
    if (sourceLanguage === targetLang) return sourceText;

    // LocalStorage cache check
    const localTranslations =
      JSON.parse(localStorage.getItem("translations")) || {};
    if (
      localTranslations[targetLang] &&
      localTranslations[targetLang][sourceText]
    ) {
      return localTranslations[targetLang][sourceText];
    }

    const accessToken = await getAccessTokenSilently({
      authorizationParams: {
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      },
    });

    const url = `${process.env.REACT_APP_API_BASE_URL}/translate`;

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json", 
        },
        body: JSON.stringify({ sourceText, targetLang, sourceLanguage }),
      });

      const data = await response.json();

      if (!response.ok) {
        console.error("Backend error:", data.detail);
        return null;
      }

      // Save to local cache
      const translations =
        JSON.parse(localStorage.getItem("translations")) || {};
      translations[targetLang] = translations[targetLang] || {};
      translations[targetLang][sourceText] = data.translatedText;
      localStorage.setItem("translations", JSON.stringify(translations));

      return data.translatedText;
    } catch (error) {
      console.error("Translation error:", error);
      return null;
    }
  };

  return { translateText };
};
